import get from 'lodash/get';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import Notification from '../notification';
import MainMenu from '../nav_main_menu/nav_main_menu';
import mainMenuContext from '../nav_main_menu/nav_main_menu_data';
import Search from '../search/search';
import matchMediaDesktop from '../../../utils/client_util';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';

export default class Nav extends Component {
  constructor() {
    super();

    this.state = {
      scale: false,
      menu: false,
      search: false
    };

    this.setNavScale = this.setNavScale.bind(this);
    this.getCategoryData = this.getCategoryData.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenuIfOpen = this.closeMenuIfOpen.bind(this);
    this.toggleSearchModal = this.toggleSearchModal.bind(this);
    this.renderCategoryLink = this.renderCategoryLink.bind(this);
    this.renderPageTitle = this.renderPageTitle.bind(this);
  }

  componentDidMount() {
    if (matchMediaDesktop()) {
      window.addEventListener('scroll', this.setNavScale);
    }
  }

  setNavScale() {
    const { scrollY } = window;
    const { scale } = this.state;
    const featureFlags = get(this.props, 'config.featureFlags');

    if (this.props.isHome && featureFlags.topNavAdEnabled) {
      this.setState({ scale: false });
    } else {
      if (scale && scrollY <= 20) {
        this.setState({ scale: false });
      }

      if (!scale && scrollY > 20) {
        this.setState({ scale: true });
      }
    }
  }

  getCategoryData(topic) {
    let className = 'nav__link';
    const active = topic.url === get(this.props, 'activeCategory');

    if (active) {
      className = ' nav__active';
    }

    return { className, active };
  }

  setHeaderClass(menu, isHome) {
    const featureFlags = get(this.props, 'config.featureFlags');
    let className = 'page-header';

    if (menu) {
      className += ' page-header--menu';
    }

    // For when we have homepage ad, manually add this for now for now
    if (isHome && featureFlags.topNavAdEnabled) {
      className += ' page-header--with-top-ad';
    }
    return className;
  }

  toggleMenu(event) {
    const { menu } = this.state;
    const html = document.querySelector('html');
    const addRemove = menu ? 'remove' : 'add';
    this.setState({ menu: !menu, search: false });

    html.classList[addRemove]('no-scroll');

    if (event) {
      event.preventDefault();
    }
  }

  closeMenuIfOpen() {
    if (this.state.menu) {
      this.toggleMenu();
    }
  }

  toggleSearchModal(triggerFocus = true) {
    if (triggerFocus && window.location.pathname.includes('/search')) {
      document.querySelector('.search-form__input--in-page').focus();
      return;
    }

    this.setState({ search: !this.state.search });
  }

  renderCategoryLink(topic) {
    const { url, title, external } = topic;
    const data = this.getCategoryData(topic);
    const attrs = {
      className: data.className,
      title
    };

    if (data.active) {
      return <span {...attrs}>{title}</span>;
    }

    if (external) {
      attrs.href = `//${url}`;
      return (
        <a
          {...attrs}
          onClick={() => {
            trackGAEvent({
              eventCategory: 'Interaction',
              eventAction: 'Top Nav Category',
              eventLabel: title
            });
          }}
        >
          {title}
        </a>
      );
    }

    attrs.to = url;
    return (
      <Link
        {...attrs}
        onClick={() => {
          trackGAEvent({
            eventCategory: 'Interaction',
            eventAction: 'Top Nav Category',
            eventLabel: title
          });
        }}
      >
        {title}
      </Link>
    );
  }

  renderPageTitle() {
    const { isHome, title } = this.props;
    const { scale } = this.state;
    let className = 'page-header__title';

    if (scale) {
      className += ' page-header__title--scaled';
    }

    if (isHome) {
      return <h2 className={className}>{title}</h2>;
    }

    return (
      <Link to="/" className={className}>
        {title}
      </Link>
    );
  }

  render() {
    const {
      notification,
      isHome,
      topics,
      config,
      newsletterLink
      // subscribeLink
    } = this.props;
    const subscribeLink = 'https://magazine.fastcompany.com/loc/FST/1102'; // Temporary value
    const { menu, search, scale } = this.state;
    const site = get(config, 'site', '');
    const social = get(mainMenuContext, `social.${site}`, []);

    // When we want to A/B test this link

    return (
      <header
        className={this.setHeaderClass(menu, isHome)}
        onClick={this.closeMenuIfOpen}
      >
        <div className="nav__main-items">
          {this.renderPageTitle()}
          <ul
            className={`nav__extras nav__extras--left ${
              scale ? 'nav__extras--scaled' : ''
            }`}
          >
            <a
              className={scale ? 'nav__menu__scaled' : 'nav__menu'}
              onClick={this.toggleMenu}
            >
              <img
                src="https://images.fastcompany.net/image/upload/v1540915228/fcweb/3_Line_Burger_ffffff2x_tiojxh.svg"
                className="nav__menu__hamburger"
                alt="Menu"
              />
            </a>

            <li
              className={
                scale
                  ? 'nav__extras-item nav__menu-lower__scaled'
                  : 'nav__extras-item nav__menu-lower'
              }
            >
              <a className="nav__newsletter" href={newsletterLink}>
                Newsletter
              </a>
            </li>
            <li
              className={
                scale
                  ? 'nav__extras-item nav__menu-lower__scaled'
                  : 'nav__extras-item nav__menu-lower'
              }
            >
              <a href={subscribeLink} className="nav__subscribe">
                Subscribe
              </a>
            </li>
          </ul>

          <ul
            className={`nav__extras nav__extras--right ${
              scale ? 'nav__extras--scaled' : ''
            }`}
          >
            <li className="nav__extras-item">
              {social.map(network => (
                <a
                  key={network.url}
                  href={network.url}
                  className={`nav__social-button nav__social-button--${
                    network.property
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    trackGAEvent({
                      eventCategory: 'Social',
                      eventAction: 'Top Nav Follow Us',
                      eventLabel: network.property
                    });
                  }}
                >
                  <i
                    className={`nav__icon nav__icon--${network.property} icon-${
                      network.property
                    }`}
                  />
                </a>
              ))}
            </li>
            <li className="nav__extras-item">
              <button
                className="nav__search-trigger"
                onClick={this.toggleSearchModal}
              >
                <i className="icon-search-glass" />
              </button>
            </li>
          </ul>
        </div>
        <nav className="nav">
          <ul className="nav__list">
            {topics.map(topic => (
              <li
                key={topic.title}
                className={
                  topic.title === 'Recommender'
                    ? 'nav__item nav__item__remove'
                    : 'nav__item'
                }
              >
                {this.renderCategoryLink(topic)}
              </li>
            ))}
          </ul>
        </nav>
        <Search
          skin="light"
          modifier="overlay"
          active={search}
          modal={true}
          closeModal={this.toggleSearchModal}
        />
        <MainMenu
          closeMenu={this.toggleMenu}
          mainMenuVisible={menu}
          scaled={this.state.scale}
          {...mainMenuContext}
          config={config}
          topics={topics}
        />
        {notification.message ? (
          <Notification
            message={notification.message}
            callback={notification.callback}
          />
        ) : null}
      </header>
    );
  }
}

Nav.propTypes = {
  notification: PropTypes.shape({}).isRequired,
  isHome: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subscribeLink: PropTypes.string.isRequired,
  newsletterLink: PropTypes.string.isRequired,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool, // eslint-disable-next-line react/no-unused-prop-types
      title: PropTypes.string.isRequired, // eslint-disable-next-line react/no-unused-prop-types
      url: PropTypes.string.isRequired // eslint-disable-next-line react/no-unused-prop-types
    })
  ).isRequired,
  config: PropTypes.shape({}).isRequired
};
